import { FETCH_LOCATIONS} from "../actionTypes";
import { fetchLocations } from "../../../api/newService/newService.service";

const request = () => ({ type: FETCH_LOCATIONS.REQUEST });
const failure = (error) => ({ type: FETCH_LOCATIONS.FAILURE,error });
const success = (data) => ({ type: FETCH_LOCATIONS.SUCCESS,data});

export const getLocations = () => {
  return (dispatch, getState) => {
    dispatch(request());
    return fetchLocations()
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve(true);

      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve(false);
      });
  };
};
